import React from "react";
import { Link, Route } from "wouter";
import { AccountSettings } from "@/pages/settings/AccountSettings.tsx";
import { ArrowLeftIcon } from "lucide-react";
import { LooksSettings } from "@/pages/settings/LooksSettings.tsx";
import { UpdatesSettings } from "@/pages/settings/UpdatesSettings.tsx";

const DesktopSettingsPage: React.FC = (props) => {
	return (
		<div className={"flex justify-center items-center min-h-screen"}>
			<div className={"w-full max-w-[600px] shadow-xl border rounded"}>
				<div className={"border-b p-4 flex gap-4 items-center"}>
					<a href={"/"}>
						<ArrowLeftIcon className={"w-6 h-6"} />
					</a>
					<h1 className={"text-xl"}>Settings</h1>
				</div>
				<div className={"grid grid-cols-[150px_1fr]"}>
					<div className={"flex flex-col gap-2 p-3 h-full border-r"}>
						<Link
							className={
								"flex p-1 rounded hover:bg-primary/20"
							}
							to={"/account"}
						>
							Account
						</Link>
						<Link
							className={
								"flex p-1 rounded hover:bg-primary/20"
							}
							to={"/looks"}
						>
							Appearance
						</Link>
						<Link
							className={
								"flex p-1 rounded hover:bg-primary/20"
							}
							to={"/updates"}
						>
							Updates
						</Link>
					</div>
					<Route path={"/account"} component={AccountSettings} />
					<Route path={"/looks"} component={LooksSettings} />
					<Route path={"/updates"} component={UpdatesSettings} />
				</div>
			</div>
		</div>
	);
};

export { DesktopSettingsPage };
